import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = a((h, s) => /* @__PURE__ */ l.jsx(
  e,
  {
    ref: s,
    ...h,
    image: (c) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip0_2974_4147)", children: [
            /* @__PURE__ */ l.jsx(
              "mask",
              {
                id: "mask0_2974_4147",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ l.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M37.21 36.15V24c0-.41-.34-.75-.75-.75h-7.72c-.41 0-.75.34-.75.75v2.93L25.06 24l4.7-4.7v2.17c0 .41.34.75.75.75s.75-.34.75-.75V17.8l2.68-2.68v6.36c0 .41.34.75.75.75s.75-.34.75-.75v-7.86l4.34-4.34c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-4.14 4.14-3.8-1.53a.76.76 0 0 0-.7.07c-.21.14-.33.37-.33.62v5.66L24 22.94l-5.96-5.96c.11-.13.18-.29.18-.47 0-.41-.34-.75-.75-.75h-.65l-.69-.69v-.3h1.34a.749.749 0 1 0 0-1.5h-1.34v-1h1.34a.749.749 0 1 0 0-1.5h-4.18c-.4 0-.72.32-.74.71L9.28 8.22a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l4.41 4.41a.63.63 0 0 0-.09.33c0 .41.34.75.75.75h.42l.92.92v.07h-1.34c-.41 0-.75.34-.75.75s.34.75.75.75h1.34v1h-1.34c-.41 0-.75.34-.75.75s.34.75.75.75h1.34v1.72c0 .41.34.75.75.75s.75-.34.75-.75v-1.72h1.34c.33 0 .61-.22.7-.52L22.94 24l-2.95 2.95V24c0-.41-.34-.75-.75-.75h-7.72c-.41 0-.75.34-.75.75v12.17l-2.55 2.55c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2.55-2.55h7.41c.41 0 .75-.34.75-.75v-7.41L24 25.06l3.99 3.99v7.43c0 .41.34.75.75.75h7.43l2.55 2.55c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06zm-5.95-23.52 2.17.87-2.17 2.17zm-16.63-.36v1h-.3l-1-1zm1.5 5.99v-1h.07l1 1zm-3.86 6.49h6.22v3.7l-6.22 6.22zm6.22 10.98h-5.16l5.16-5.16zm11-10.98h6.22v9.9l-6.22-6.22zm0 10.98v-5.18l5.18 5.18z"
                  }
                )
              }
            ),
            /* @__PURE__ */ l.jsx("g", { mask: "url(#mask0_2974_4147)", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_2974_4147", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyNoMakeupIcon";
export {
  i as AgencyNoMakeupIcon,
  i as default
};
//# sourceMappingURL=index.js.map
